var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Organization } from '@/models/Organization';
import DataTable from '@/components/data-table/DataTable';
import { School } from '@/models/School';
import { avatarHtml } from '@/support/String';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        // #endregion
        super(...arguments);
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.currentStep = 1;
        this.isLoading = false;
        this.organization = new Organization();
        this.selectedSchools = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #region Getters & Setters
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('school.title', 1),
                plural: this.$tc('school.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$tc('name.title'),
                    value: 'name',
                    action: '/admin/schools/{id}',
                },
            ],
            actions: [],
            filters: [],
            model: new School(),
        };
    }
    get tableVisibility() {
        return {
            limit: false,
        };
    }
    deleteSelectedSchool(index) {
        this.selectedSchools.splice(index, 1);
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.getSubjects();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    close() {
        this.reset();
        this.$emit('input', false);
    }
    reset() {
        // HERE
    }
    // #endregion
    // #region Async methods
    async getSubjects() {
        // FIXME
        // try {
        //   this.areas = await new Subject()
        //     .filter(extendedFilters)
        //     .limit(100)
        //     .include('children')
        //     .all();
        // } catch (error) {
        // }
    }
    async onClickCreate() {
        // this.isLoading = true;
        // const payload: any = this.organization.clone();
        // const project: Organization = await payload
        //   .create()
        //   .catch(((error: AxiosError) => { ErrorHandler.network(error) }));
        // if (project) {
        //   this.$emit('project:created');
        //   this.close();
        // }
    }
};
CreateDialog = __decorate([
    Component({
        components: {
            DataTable,
            SelectFilter,
        },
    })
], CreateDialog);
export default CreateDialog;
